import React from 'react';
import { Icon} from "@blueprintjs/core";
const NotificationIcon = ({count, size = 20, ...props }) => {
    return (
            <div className="relative inline-block" {...props}>
                <Icon size={size} icon={"notifications"} />
                {count > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                        {/* 如果数量超过99，可以显示为 "99+" */}
                    {count > 99 ? '99+' : count}
                    </span>
                )}
            </div>
        );
};

export default NotificationIcon;
